@if (!formSubmitted && (formModelRef.errors && (formModelRef.dirty || formModelRef.touched))) {
  <small
    class="form-text error">
    @if (inputType !== 'date') {
      <mat-error>
        <small [hidden]="!formModelRef.errors.required">
          {{errorCodesList[0] | translate}}
        </small>
        <small [hidden]="!formModelRef.hasError('pattern')">
          {{errorCodesList[1] | translate}}
        </small>
        <small [hidden]="!formModelRef.hasError('min')">
          {{errorCodesList[2] ? errorCodesList[2] : 'Minimum date issue' | translate }}
        </small>
        <small [hidden]="!formModelRef.hasError('maxlength')">
          {{errorCodesList[3] ?errorCodesList[3]:'Maxlength exceeded' | translate }}
        </small>
        <small [hidden]="!errorCodesList[4]">
          {{errorCodesList[4] | translate}}
        </small>
        <small [hidden]="!formModelRef.hasError('max')">
          {{errorCodesList[5] ?errorCodesList[5]:'Maximum value exceeded' | translate }}
        </small>
      </mat-error>
    }
    @if (inputType === 'date') {
      <mat-error>
        <small [hidden]="!formModelRef.errors.required || formModelRef.errors?.matDatepickerParse || formModelRef.errors?.matDatepickerMin || formModelRef.errors?.matDatepickerMax">
          {{errorCodesList[0] | translate}}
        </small>
        <small [hidden]="!formModelRef.errors?.matDatepickerParse">
          {{errorCodesList[1] ? errorCodesList[1] : 'Enter valid date format' | translate }}
        </small>
        <small [hidden]="!formModelRef.errors?.matDatepickerMin">
          {{errorCodesList[2] ? errorCodesList[2] : 'Date selected before min date' | translate }}
        </small>
        <small [hidden]="!formModelRef.errors?.matDatepickerMax">
          {{errorCodesList[3] ? errorCodesList[3] : 'Date selected after max date' | translate }}
        </small>
        <small [hidden]="formModelRef.errors?.matDatepickerParse || formModelRef.errors?.matDatepickerMin || formModelRef.errors?.matDatepickerMax || !errorCodesList[4]">
          {{errorCodesList[4] | translate }}
        </small>
      </mat-error>
    }
  </small>
}
@if ((formSubmitted && !formModelRef.pristine) && (formModelRef.errors && (formModelRef.dirty || formModelRef.touched))) {
  <small
    class="form-text error">
    @if (formModelRef.errors && inputType !== 'date') {
      <mat-error>
        <small [hidden]="!formModelRef.errors.required">
          {{errorCodesList[0] | translate}}
        </small>
        <small [hidden]="!formModelRef.hasError('pattern')">
          {{errorCodesList[1] | translate}}
        </small>
        <small [hidden]="!formModelRef.hasError('min')">
          {{errorCodesList[2] ? errorCodesList[2] : 'Minimum date issue' | translate }}
        </small>
        <small [hidden]="!formModelRef.hasError('maxLength')">
          {{errorCodesList[3] ?errorCodesList[3]:'Maxlength exceeded' | translate }}
        </small>
        <small [hidden]="!errorCodesList[4]">
          {{errorCodesList[4] | translate}}
        </small>
        <small [hidden]="!formModelRef.hasError('max')">
          {{errorCodesList[5] ?errorCodesList[5]:'Maximum value exceeded' | translate }}
        </small>
      </mat-error>
    }
    @if (formModelRef.errors && inputType === 'date') {
      <mat-error>
        <small [hidden]="!formModelRef.errors.required || formModelRef.errors?.matDatepickerParse || formModelRef.errors?.matDatepickerMin || formModelRef.errors?.matDatepickerMax">
          {{errorCodesList[0]}}
        </small>
        <small [hidden]="!formModelRef.errors?.matDatepickerParse">
          {{errorCodesList[1] ? errorCodesList[1] : 'Enter valid date format' | translate }}
        </small>
        <small [hidden]="!formModelRef.errors?.matDatepickerMin">
          {{errorCodesList[2] ? errorCodesList[2] : 'Date selected before min date' | translate }}
        </small>
        <small [hidden]="!formModelRef.errors?.matDatepickerMax">
          {{errorCodesList[3] ? errorCodesList[3] : 'Date selected after max date' | translate }}
        </small>
        <small [hidden]="formModelRef.errors?.matDatepickerParse || formModelRef.errors?.matDatepickerMin || formModelRef.errors?.matDatepickerMax || !errorCodesList[4]">
          {{errorCodesList[4] | translate }}
        </small>
      </mat-error>
    }
  </small>
}
@if (formSubmitted && (formModelRef.pristine  && formModelRef.errors)) {
  <small class="form-text error">
    @if (formModelRef.errors && inputType !== 'date') {
      <mat-error>
        <small [hidden]="!formModelRef.errors.required">
          {{errorCodesList[0]}}
        </small>
        <small [hidden]="!formModelRef.hasError('pattern')">
          {{errorCodesList[1]}}
        </small>
        <small [hidden]="!formModelRef.hasError('min')">
          {{errorCodesList[2] ? errorCodesList[2] : 'Minimum date issue' | translate }}
        </small>
        <small [hidden]="!formModelRef.hasError('maxlength')">
          {{errorCodesList[3] ?errorCodesList[3]:'Maxlength exceeded' | translate }}
        </small>
        <small [hidden]="!errorCodesList[4]">
          {{errorCodesList[4]}}
        </small>
        <small [hidden]="!formModelRef.hasError('max')">
          {{errorCodesList[5] ?errorCodesList[5]:'Maximum value exceeded' | translate }}
        </small>
      </mat-error>
    }
    @if (formModelRef.errors && inputType === 'date') {
      <mat-error>
        <small [hidden]="!formModelRef.errors.required || formModelRef.errors?.matDatepickerParse || formModelRef.errors?.matDatepickerMin || formModelRef.errors?.matDatepickerMax">
          {{errorCodesList[0]}}
        </small>
        <small [hidden]="!formModelRef.errors?.matDatepickerParse">
          {{errorCodesList[1] ? errorCodesList[1] : 'Enter valid date format' | translate }}
        </small>
        <small [hidden]="!formModelRef.errors?.matDatepickerMin">
          {{errorCodesList[2] ? errorCodesList[2] : 'Date selected before min date' | translate }}
        </small>
        <small [hidden]="!formModelRef.errors?.matDatepickerMax">
          {{errorCodesList[3] ? errorCodesList[3] : 'Date selected after max date' | translate }}
        </small>
        <small [hidden]="formModelRef.errors?.matDatepickerParse || formModelRef.errors?.matDatepickerMin || formModelRef.errors?.matDatepickerMax || !errorCodesList[4]">
          {{errorCodesList[4] | translate }}
        </small>
      </mat-error>
    }
  </small>
}

@if (formSubmitted && errorCodesList[4] && !formModelRef.errors) {
  <small class="form-text error">
    <mat-error>
      <small [hidden]="!errorCodesList[4]">
        {{errorCodesList[4] | translate}}
      </small>
    </mat-error>
  </small>
}